;(function($, window, document){
    window.CartTitle = Me.view.extend({
        options: {

        },

        initialize: function() {
            _.bindAll(this,'printHandler','shareHandler', 'closeShares', 'removeActionBtn', 'updateShareLink');
            this.addEvents();
        },
        addEvents: function() {
            this.$('.print-btn').on('click', this.printHandler);
            this.$('.share-btn').on('click', this.shareHandler);
            Me.dispatch.subscribe('cart.noItemsInCart', this.removeActionBtn);
            Me.dispatch.subscribe('Cart.updateShareLink', this.updateShareLink);
            Me.dispatch.subscribe('cart.bulkyOrder', this.displayBulkyOrderNotification);
        },
        closeShares: function(){
            this.$('.incubate-keep-and-share-your-cart-widget').addClass('hide');
            $('body').off('click', this.closeShares);
        },
        displayBulkyOrderNotification: function(e, params){
            if(params.isBulky){
                this.$('.error').removeClass('hide');
            }else{
                this.$('.error').addClass('hide');
            }
        },
        printHandler : function () {
            Me.track.event('Cart', 'print');
            window.print();
        },
        removeActionBtn : function () {
            this.$el.find('.action-btn').addClass('hide');
        },
        shareHandler : function () {
            var view = this;
            this.$('.incubate-keep-and-share-your-cart-widget').removeClass('hide');
            this.$('.incubate-keep-and-share-your-cart-widget').toggleClass('show');
            if (!this.$('.incubate-keep-and-share-your-cart-widget').hasClass('show')){
                setTimeout(function(){
                    $('body').on('click', view.closeShares);
                },0);
            }
            else {
                $('body').off('click', view.closeShares);
            }
        },
        updateShareLink: function(e, params){
            addthis.update('share', 'url', params.shareURL);
            //this.$('.social-icons').attr('addthis:url', params.shareURL);
        }
    });
}(jQuery, window, document));
